<div class="popup">
  <div class="content">
    <div class="top">
      <h3 class="title">{{ translation.navigation.noBarrierFreeFoundTitle | transloco }}</h3>
      <!--            <div class="top-close">-->
      <!--                <span (click)="confirm.emit()">-->
      <!--                    <cue-icon [icon]="ICONS.cueClose" />-->
      <!--                </span>-->
      <!--            </div>-->
    </div>

    <div class="inner-content">
      <p class="subtitle">
        <cue-icon [icon]="ICONS.cueExclamation" class="k-mr-2 icon" />
        {{ translation.navigation.noBarrierFreeFoundText | transloco }}
      </p>
      <p>{{ translation.navigation.noBarrierFreeFoundQuestion | transloco }}</p>
    </div>

    <div class="buttons flex justify-between">
      <button cue-button size="small" [link]="true" (click)="changeTarget.emit()">
        <cue-icon [icon]="ICONS.cuePencil" />
        {{ translation.navigation.changeTarget | transloco }}
      </button>
      <button cue-button size="small" (click)="confirm.emit()">
        <cue-icon [icon]="ICONS.cueNavigationCircle" />
        {{ translation.navigation.barrierRoute | transloco }}
      </button>
    </div>
  </div>
</div>
